export const RRS_DEBT_FREE = {
  type: 'article',
  image: 'https://scoopr.no/static/media/person_yellow.0b4f9641.webp',
  headline: 'Gjeldfri så fort som mulig?',
  url: 'https://scoopr.no/gjeldfri',
  description:
    'Det å bli gjeldfri kan virke fjernt, men er langt fra umulig. Vil du bli gjeldfri så fort som mulig? Vi har rådene.',
  datePublished: '2022-01-04T08:00:00+00:00',
  dateModified: '2022-01-26T08:00:00+00:00',
};
